import { createContext, useContext, useState, useEffect } from "react";

export const NAVY = "#132743";
export const ACCENT = "#2f6fed";

export const THEMES = {
  light: {
    bg: "#f4f5f7", panel: "#ffffff", border: "#e3e6ea", text: "#1a1f29",
    muted: "#6b7280", mutedLight: "#9aa2b1", tableHead: "#f7f8fa", rowBorder: "#f3f4f6",
    error: "#c0392b",
  },
  dark: {
    bg: "#10131a", panel: "#1a1e27", border: "#2b303c", text: "#e8eaef",
    muted: "#9aa3b5", mutedLight: "#6b7386", tableHead: "#20242f", rowBorder: "#262b37",
    error: "#ff8a80",
  },
};

const ThemeContext = createContext(null);

export function ThemeProvider({ children, sidebarOpen, onToggleSidebar }) {
  const [dark, setDark] = useState(() => {
    try {
      const saved = localStorage.getItem("dashboard_theme");
      if (saved) return saved === "dark";
    } catch {}
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  const toggle = () => setDark(d => {
    try { localStorage.setItem("dashboard_theme", d ? "light" : "dark"); } catch {}
    return !d;
  });

  const t = dark ? THEMES.dark : THEMES.light;

  useEffect(() => {
    document.body.style.background = t.bg;
  }, [t.bg]);

  return (
    <ThemeContext.Provider value={{ dark, toggle, t, sidebarOpen, onToggleSidebar }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useAppTheme() {
  const ctx = useContext(ThemeContext);
  if (ctx) return ctx;
  // Fallback for standalone usage outside ThemeProvider
  return null;
}

export function useIsMobile() {
  const query = "(max-width: 640px)";
  const [mobile, setMobile] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = e => setMobile(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return mobile;
}
